var i = 0;
module.exports = function(prefix){
  return function(){
    i++;
    return prefix + i.toString(36);
  };
};



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/gen-css-identifier/factory.js
// module id = 1972
// module chunks = 7